import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ListPeriodeFilter,
  ListPeriodeResponse,
  PeriodeData,
} from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';

@Injectable()
export class PeriodeService {
  constructor(private http: HttpClient) {}

  listPeriode(filter: ListPeriodeFilter): Observable<ListPeriodeResponse> {
    let params = new HttpParams();

    if (filter.date) {
      params = params.append('date', filter.date.toString());
    }

    if (filter.month > 0) {
      params = params.append('month', filter.month.toString());
    }

    if (filter.year) {
      params = params.append('year', filter.year.toString());
    }

    if (filter.cabang) {
      filter.cabang.forEach((b) => {
        params = params.append('cabang[]', b);
      });
    }

    if (filter.jenjang) {
      filter.jenjang.forEach((b) => {
        params = params.append('jenjang[]', b);
      });
    }

    if (filter.year) {
      params = params.append('year', filter.year.toString());
    }

    if (filter.status) {
      params = params.append('status', filter.status.toString());
    }

    if (filter.periode_from) {
      params = params.append('periode_from', filter.periode_from);
    }

    if (filter.periode_to) {
      params = params.append('periode_to', filter.periode_to);
    }

    params = params.append('page', filter.page.toString());
    params = params.append('per_page', filter.per_page.toString());

    return this.http.get<ListPeriodeResponse>(
      environment.apiUrl + 'clientapi/admin/periode',
      { params }
    );
  }

  savePeriode(data: PeriodeData): Observable<any> {
    if (data.id) {
      return this.http.put(
        environment.apiUrl + 'clientapi/admin/periode',
        data
      );
    } else {
      return this.http.post(
        environment.apiUrl + 'clientapi/admin/periode',
        data
      );
    }
  }

  getAllPeriode(status?: any): Observable<any> {
    let params = new HttpParams();

    if (status) {
      params = params.append('status', status);
    }
    return this.http.get(environment.apiUrl + 'clientapi/admin/periode/all', {
      params,
    });
  }

  getPeriodeByBranch(filter: ListPeriodeFilter): Observable<any> {
    let params = new HttpParams();

    if (filter.cabang) {
      filter.cabang.forEach((b) => {
        params = params.append('cabang[]', b);
      });
    }

    if(filter.status){
      params = params.append('status', filter.status.toString());
    }

    return this.http.get(environment.apiUrl + 'clientapi/admin/periode/all', {
      params,
    });
  }
}
